import { ArrowUpRight } from "lucide-react";
import { SITE, NAV_LINKS } from "../config/site";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/[0.07] bg-[#04050a]" data-testid="footer">
      <div
        className="pointer-events-none absolute left-1/2 top-0 h-px w-2/3 -translate-x-1/2 bg-gradient-to-r from-transparent via-indigo-400/50 to-transparent"
        aria-hidden="true"
      />
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-3">
          <div>
            <a href="#home" className="flex items-center gap-2.5" data-testid="footer-logo">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-to-br from-indigo-500 to-purple-600 font-display text-sm font-extrabold text-white shadow-[0_0_18px_rgba(129,140,248,0.5)]">
                GD
              </span>
              <span className="font-display text-base font-bold text-white">
                Govind <span className="text-gradient">Developer</span>
              </span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-400">
              Professional AI website developer — creating modern, responsive
              and conversion-focused websites, from concept to live website.
            </p>
          </div>

          <div>
            <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.3em] text-slate-500">
              Menu
            </p>
            <ul className="mt-5 grid grid-cols-2 gap-x-6 gap-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="group inline-flex items-center gap-1 text-sm text-slate-400 transition-colors hover:text-white"
                  >
                    {l.label}
                    <ArrowUpRight className="h-3 w-3 opacity-0 transition-opacity group-hover:opacity-100" />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.3em] text-slate-500">
              Contact
            </p>
            <ul className="mt-5 space-y-3 text-sm text-slate-400">
              <li>
                <a href={SITE.phoneHref} data-testid="footer-phone-link" className="transition-colors hover:text-white">
                  {SITE.phone}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${SITE.email}`}
                  data-testid="footer-email-link"
                  className="break-all transition-colors hover:text-white"
                >
                  {SITE.email}
                </a>
              </li>
              <li data-testid="footer-location">{SITE.location}</li>
            </ul>
            <a
              href="#contact"
              data-testid="footer-cta"
              className="btn-primary mt-6 inline-flex items-center gap-1.5 rounded-full px-5 py-2.5 text-[13px] font-semibold text-white"
            >
              Start a Project <ArrowUpRight className="h-3.5 w-3.5" />
            </a>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-3 border-t border-white/[0.06] pt-7 sm:flex-row">
          <p className="text-[13px] text-slate-500" data-testid="footer-copyright">
            © {SITE.name}. All Rights Reserved.
          </p>
          <div className="flex items-center gap-5">
            <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-slate-600">
              AI Website Developer — India
            </p>
            <a
              href="/admin"
              data-testid="footer-admin-login"
              className="font-mono text-[10px] uppercase tracking-[0.28em] text-slate-600 transition-colors hover:text-indigo-300"
            >
              Admin Login
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
